<template>
	<div id="app2">
		<UserMenu></UserMenu>
		<TimeLine></TimeLine>
		
	</div>
</template>

<script>
   
	import TimeLine from '../components/TimeLine.vue';		
	import UserMenu from '../components/UserMenu.vue';	
   
	
    export default {
        name: 'app2',
		components:
			{ TimeLine , UserMenu },
				mounted: function () {
		
		}
    };
</script>

